import ApiService from './ApiService';
import AuthService from './AuthService';

class FilterInfoService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._manufacturerUrl = '/filters/manufacturers';
        this._regionsUrl = '/filters/regions';
        this._searchUrl = '';
    }

    setManufacturerSearch() {
        this._searchUrl = this._manufacturerUrl;
    }

    setRegionsSearch() {
        this._searchUrl = this._regionsUrl;
    }

    getSearch(params) {
        if(!params) {
            params = {};
        }

        return this.postResource(this._searchUrl, params, this.getLangHeader())
    }
}

const service = new FilterInfoService(AuthService);

export default service;
